import AntLocalization from './AntLocalization';
import formatHelper from 'devextreme/format_helper';

const isObjectText = (value) => typeof value === 'string' && /^\[object Object\]$/i.test(value.trim());

const getValue = (value) => {
    if (value === null || value === undefined) return '';
    if (value instanceof Array) return value.map((item) => getValue(item)).filter(Boolean).join(', ');
    if (typeof value !== 'object') return AntLocalization.translateText(value);

    // FK/lookup values returned by prepare APIs may still be objects instead of
    // the scalar shown by AntGrid. Prefer the configured display field, then
    // the conventional localized lookup fields.
    const displayValue = value.name ?? value.label ?? value.display_name ?? value.text ?? value.code ?? value.id;
    if (displayValue === value) return '';
    return getValue(displayValue);
};

export const getGridDisplayValue = (cell, column = {}, formatForMeasurement = false) => {
    const rawValue = cell?.value !== undefined ? cell.value : cell?.data?.[column.dataField];
    let value = cell?.text;

    // DevExtreme has already applied calculateDisplayValue/format to text. Only
    // fall back when it has no text or has stringified an object as [Object Object].
    if (value === undefined || value === null || isObjectText(value)) {
        try {
            if (typeof column.calculateDisplayValue === 'function') value = column.calculateDisplayValue(cell?.data);
            else if (typeof column.calculateCellValue === 'function') value = column.calculateCellValue(cell?.data);
            else value = rawValue;
        } catch (_) {
            value = rawValue;
        }
    }

    if (value && typeof value === 'object' && !(value instanceof Date)) {
        const displayField = column.displayField || column.lookup?.displayField || column.lookup?.displayExpr;
        if (displayField && value[displayField] !== undefined) value = value[displayField];
    }

    if (formatForMeasurement && cell?.text === undefined) {
        if (value && typeof value === 'object' && !(value instanceof Date)) value = getValue(value);
        const valueText = formatHelper.format(value, column.format) || (value == null ? '' : String(value));
        return String(column.customizeText ? column.customizeText.call(column, { value, valueText, target: 'row' }) : valueText);
    }
    return getValue(value);
};

export default getGridDisplayValue;
